// HeaderL1L2QA.js
import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./HeaderL1L2QA.css";
import { AccountCircle, Help, Logout, ChatBubble, NetworkPing, FormatListBulleted } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import { useChatNotifications } from "../Chat/useChatNotifications";
import iconsidemenu from "../img/iconsidemenu.png"

const HeaderL1L2QA = ({ user, userRole, onSignOut }) => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  
  // Get chat notifications
  const { unreadCount, markAllAsRead } = useChatNotifications();

  const toggleProfileMenu = () => {
    console.log('L1L2QA profile menu clicked, current state:', isProfileMenuOpen);
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const closeProfileMenu = () => {
    setIsProfileMenuOpen(false);
  };

  return (
    <header className="HeaderL1L2QA__sidebar-header">
      <div className="HeaderL1L2QA__sidebar-content">
        {/* Logo gris */}
        <div className="HeaderL1L2QA__sidebar-logo">
         <img src={iconsidemenu} alt="" />
        </div>

        {/* Navigation verticale */}
        <nav className="HeaderL1L2QA__sidebar-nav">
          <NavLink
            to="/Backlog"
            className={({ isActive }) =>
              `HeaderL1L2QA__sidebar-nav-link ${isActive ? "HeaderL1L2QA__sidebar-nav-link--active" : ""}`
            }
            title="Backlog"
          >
            <FormatListBulleted className="HeaderL1L2QA__sidebar-nav-icon" />
          </NavLink>

      
          <NavLink
            to="/chat"
            className={({ isActive }) =>
              `HeaderL1L2QA__sidebar-nav-link ${isActive ? "HeaderL1L2QA__sidebar-nav-link--active" : ""}`
            }
            title="Chat"
            onClick={() => markAllAsRead()}
          >
            <div className="HeaderL1L2QA__sidebar-chat-container">
              <ChatBubble className="HeaderL1L2QA__sidebar-nav-icon" />
              {unreadCount > 0 && (
                <span className="HeaderL1L2QA__sidebar-chat-badge">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
          </NavLink>
          <NavLink
            to="/statistics"
            className={({ isActive }) =>
              `HeaderL1L2QA__sidebar-nav-link ${isActive ? "HeaderL1L2QA__sidebar-nav-link--active" : ""}`
            }
            title="Statistics"
          >
            <NetworkPing className="HeaderL1L2QA__sidebar-nav-icon" />
          </NavLink>

          <NavLink
            to="/help"
            className={({ isActive }) =>
              `HeaderL1L2QA__sidebar-nav-link ${isActive ? "HeaderL1L2QA__sidebar-nav-link--active" : ""}`
            }
            title="Help Center"
          >
            <Help className="HeaderL1L2QA__sidebar-nav-icon" />
          </NavLink>

        </nav>

        {/* Photo de profil en bas */}
        <div className="HeaderL1L2QA__sidebar-user">
          <button className="HeaderL1L2QA__sidebar-profile-button" onClick={toggleProfileMenu}>
            {user?.photoURL ? (
              <img 
                src={user.photoURL} 
                alt="Profile" 
                className="HeaderL1L2QA__sidebar-profile-avatar"
                referrerPolicy="no-referrer"
              />
            ) : (
              <AccountCircle className="HeaderL1L2QA__sidebar-profile-avatar-icon" />
            )}
          </button>
        </div>

        {/* Profile Menu Portal */}
        {isProfileMenuOpen && ReactDOM.createPortal(
          <div className="HeaderL1L2QA__modal__overlay" onClick={closeProfileMenu}>
            <div className="HeaderL1L2QA__modal__content" onClick={(e) => e.stopPropagation()}>
              <div className="HeaderL1L2QA__modal__header">
                <div className="HeaderL1L2QA__modal__user-info">
                  {user?.photoURL ? (
                    <img 
                      src={user.photoURL} 
                      alt="Profile" 
                      className="HeaderL1L2QA__modal__avatar"
                      referrerPolicy="no-referrer"
                    />
                  ) : (
                    <AccountCircle className="HeaderL1L2QA__modal__avatar-icon" />
                  )}
                  <div className="HeaderL1L2QA__modal__user-details">
                    <h3>{user.email}</h3>
                    <div className="HeaderL1L2QA__modal__user-role">
                      {userRole}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="HeaderL1L2QA__modal__actions">
                <button 
                  className="HeaderL1L2QA__modal__button" 
                  onClick={() => { window.location.href = '/help'; closeProfileMenu(); }}
                >
                  <Help className="HeaderL1L2QA__modal__button-icon" />
                  <span>Help Center</span>
                </button>
                <button 
                  className="HeaderL1L2QA__modal__button HeaderL1L2QA__modal__button--logout" 
                  onClick={() => { onSignOut(); closeProfileMenu(); }}
                >
                  <Logout className="HeaderL1L2QA__modal__button-icon" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
      </div>
    </header>
  );
};

export default HeaderL1L2QA;